/** English nickname parts, used on every market: gamer-style handles read the
 *  same in Istanbul, Paris and Berlin. `words` are single handles ("Phoenix");
 *  adjective + noun compose "DarkBlade"-style handles. */
export const NICK_EN = {
  words: [
    'Excalibur', 'Phoenix', 'Shadow', 'Raven', 'Storm', 'Viper', 'Blaze', 'Titan', 'Falcon', 'Specter',
    'Nova', 'Cipher', 'Vortex', 'Reaper', 'Onyx', 'Cobra', 'Maverick', 'Zenith', 'Rogue', 'Phantom',
    'Comet', 'Vandal', 'Saber', 'Hydra', 'Goliath', 'Echo', 'Drift', 'Pulse', 'Wraith', 'Crimson',
    'Luna', 'Stella', 'Aurora', 'Nyx', 'Lyra', 'Orion', 'Atlas', 'Apollo', 'Artemis', 'Athena',
    'Kairos', 'Zephyr', 'Solstice', 'Eclipse', 'Nebula', 'Quasar', 'Pixel', 'Glitch', 'Byte', 'Neon',
    'Mochi', 'Cookie', 'Peach', 'Honey', 'Cherry', 'Mango', 'Kiwi', 'Bubbles', 'Sunny', 'Daisy',
    'Bandit', 'Ghost', 'Joker', 'Ninja', 'Samurai', 'Ronin', 'Spartan', 'Viking', 'Pirate', 'Outlaw',
    'Karma', 'Mystic', 'Oracle', 'Rebel', 'Legend', 'Hero', 'Icon', 'Chief', 'Boss', 'Ace',
    'Sparrow', 'Panther', 'Jaguar', 'Lynx', 'Wolfie', 'Foxy', 'Koala', 'Panda', 'Tiger', 'Hawk',
    'Breeze', 'Ember', 'Frost', 'Thunder', 'Rain', 'Misty', 'Willow', 'Ivy', 'Sage', 'Jade',
  ],
  adjectives: [
    'Dark', 'Iron', 'Silent', 'Wild', 'Crimson', 'Frost', 'Night', 'Lone', 'Swift', 'Savage',
    'Golden', 'Silver', 'Hollow', 'Burning', 'Frozen', 'Electric', 'Toxic', 'Royal', 'Mad', 'Lucky',
    'Sweet', 'Lazy', 'Sleepy', 'Happy', 'Crazy', 'Tiny', 'Little', 'Big', 'Cool', 'Chill',
    'Blue', 'Red', 'Black', 'White', 'Pink', 'Purple', 'Green', 'Neon', 'Cosmic', 'Lunar',
    'Solar', 'Stormy', 'Misty', 'Shadow', 'Ghost', 'Hidden', 'Secret', 'Brave', 'Fierce', 'Bold',
    'Rapid', 'Sonic', 'Atomic', 'Mystic', 'Magic', 'Dreamy', 'Fluffy', 'Spicy', 'Salty', 'Sunny',
  ],
  nouns: [
    'Blade', 'Wolf', 'Hawk', 'Knight', 'Fang', 'Ghost', 'Storm', 'Fox', 'Hunter', 'Drake',
    'Viper', 'Bear', 'Raven', 'Tiger', 'Skull', 'Crown', 'Arrow', 'Flame', 'Stone', 'Ace',
    'Star', 'Moon', 'Sun', 'Cloud', 'Wave', 'Rose', 'Lily', 'Cat', 'Kitten', 'Bunny',
    'Panda', 'Owl', 'Eagle', 'Shark', 'Dragon', 'Phoenix', 'Angel', 'Devil', 'Queen', 'King',
    'Prince', 'Princess', 'Rider', 'Pilot', 'Gamer', 'Player', 'Ninja', 'Wizard', 'Witch', 'Spirit',
    'Heart', 'Soul', 'Dream', 'Galaxy', 'Comet', 'Rocket', 'Bullet', 'Thunder', 'Ember', 'Frost',
  ],
} as const;
